import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { scrollTo } from "@/js/animation.js";
import { setCurrentPayment, getOrderConfirmationReference, getUnitPriceCurrencyForItem, showShippingPriceMinusDefault } from "@/js/order/order.js";
import { REGULAR_BOTTLING, orderStatus, orderStatusAdjusting, expeditionMethods, listTerms, casingWines, listWineTypes, orderAdjustmentsTypes, paymentState as _paymentState, TASTING_PHOTOS } from "@/js/lists.ts";
import { getClientAppData, isAllowedOrderWithoutPayment } from "@/js/http/auth.js";
import { getFullNameUserHtml, getFullNameUser } from "@/js/user/user.js";
import { wineNaming } from "@/js/wine/wine.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { isSameAddress } from "@/js/address";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import Error from "@/views/error/error.vue";
import adressComponent from "@/components/address/Address.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import WholesalersData from "@/components/payment/WholesalersData.vue";
import PaymentBadgeMulti from "@/components/payment/PaymentBadgeMulti.vue";
import TastingPhotoUploadFormModal from "@/components/tasting-photos/TastingPhotoUploadFormModal.vue";
import StorageTermsReference from "@/components/common/StorageTermsReference.vue";
export default {
  name: "HoldingOrderSummary",
  data: function data() {
    return {
      clientAppData: null,
      isFetchingShippingCosts: false,
      isCollapsed: false,
      sameAddress: true,
      bufferedAddresses: {
        billingAddress: null,
        deliveryAddress: null,
        isSameAddress: null
      },
      isEditingAddresses: false,
      updateAddressesToken: null,
      deliveryAddressFaultedMessage: null,
      orderCtaStyles: {},
      documents: [],
      loadingDocuments: true,
      documentDialog: false,
      isFinalizingOrder: false,
      isDecliningOrder: false,
      isCreatingAdjustment: false,
      isProcessingPayment: false,
      order: {
        id_order: null,
        buyer_term: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        status: null,
        expedition_method: 0,
        expedition_methods: {},
        delivery_address: null,
        delivery_instructions: null,
        billing_address: null,
        amount_shipping: null,
        due_date: null,
        cancellation_date: null,
        deleted: false,
        user: null,
        stockTransferIsAskedByUser: false,
        isStockTransfer: false
      },
      imagesBroken: [],
      listCountries: [],
      listStates: [],
      lastExpeditionMethod: null,
      expedition_methods: [],
      expedition_methods_ref: expeditionMethods,
      expeditionMethods: expeditionMethods,
      checkboxCGV: false,
      checkboxLawCompliance: false,
      checkboxTastingPhoto: [],
      errorLabels: {
        shipping: {},
        terms: "",
        cgv: "",
        tastingPhoto: "",
        quantity_orders: [],
        adjustment: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        cgv: {
          required: "You must accept the terms of sales, and certify you are complying with the law"
        },
        tastingPhoto: {
          required: "You must notify the restaurant to take a photo of some bottles at time of tasting"
        },
        order: {
          quantity: "You don't reach the minimum per order"
        },
        shippingType: {
          required: "You must select a shipping type"
        }
      },
      managedExceptions: {
        warning: {
          order_pricing_credit_notes_amount_invalid: "The credits applied amount exceeds the products amount."
        }
      },
      adjustmentToken: null,
      adjustments: [],
      orderAdjustmentsTypes: orderAdjustmentsTypes,
      dialogAdjustment: {
        visible: false,
        message: null,
        type: null,
        historicVisible: false
      },
      updateDeliveryInstructionsToken: null,
      editingDeliveryInstructions: false,
      isSetDeliveryAddressAsDefaultForUserAddress: false,
      tastingPhotos: {
        canManage: true,
        required: {
          isSearchPending: false,
          items: []
        },
        upload: {
          isComponentCreated: false,
          tastingPhotoRequiredId: null
        }
      },
      casingWines: casingWines,
      listTerms: listTerms,
      orderStatus: orderStatus,
      orderStatusAdjusting: orderStatusAdjusting,
      wineNaming: wineNaming,
      TASTING_PHOTOS: TASTING_PHOTOS
    };
  },
  components: {
    "wine-naming": WineNaming,
    PaymentBadgeMulti: PaymentBadgeMulti,
    adress: adressComponent,
    confirm: confirmationComponent,
    WholesalersData: WholesalersData,
    Error: Error,
    TastingPhotoUploadFormModal: TastingPhotoUploadFormModal,
    StorageTermsReference: StorageTermsReference
  },
  props: ["baseModel", "loggedUserData"],
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$baseModel;
      var _this3;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ((_this2$baseModel = _this2.baseModel) !== null && _this2$baseModel !== void 0 && _this2$baseModel.id_order) {
              _context.next = 3;
              break;
            }
            _this2.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            _this2.clientAppData = getClientAppData(_this2);
            _this2.$EventBus.$emit("loading", true);
            _this2.order = _objectSpread(_objectSpread({}, _this2.order), _this2.baseModel);
            _this2.isSetDeliveryAddressAsDefaultForUserAddress = _this2.isOrderDeliveryInstructionsDefaultUser();
            if (_this2.orderStatusAdjusting.includes(_this2.order.status)) {
              _this2.fetchAdjustments();
            }
            _this2.refetchDocs();
            _this2.sameAddress = isSameAddress(_this2.order.delivery_address, _this2.order.billing_address);
            if (!_this2.isOrderAwaitingCustomerValidation) {
              _context.next = 14;
              break;
            }
            if (_this2.order.is_destination_inbound) {
              _this2.order.stockTransferIsAskedByUser = true;
              _this2.order.is_destination_inbound = false;
            }
            _context.next = 14;
            return _this2.calculateChargeForOrder();
          case 14:
            if (!_this2.hasBeenValidated) {
              _this3 = _this2;
              request("/v1/countries?implantedMarket=true", "post", _this3.clientAppData, false, "api").then(function (response) {
                _this3.listCountries = _toConsumableArray(response.data.countries);
                _this3.listStates = _toConsumableArray(response.data.states);
              }).catch(function () {
                _this3.$toasted.show("Unable to load countries.", {
                  type: "error"
                });
              });
            }
            _this2.getRequiredTastingPhotos();
            _this2.$EventBus.$emit("loading", false);
            if (_this2.order.delivery_instructions) {
              _this2.inputDeliveryInstructions = _this2.order.delivery_instructions;
            }
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    isStoredInbound: function isStoredInbound() {
      return this.order.is_destination_inbound || this.order.isStockTransfer;
    },
    isGreatExport: function isGreatExport() {
      var _this$order;
      return !((_this$order = this.order) !== null && _this$order !== void 0 && (_this$order = _this$order.delivery_address) !== null && _this$order !== void 0 && (_this$order = _this$order.country) !== null && _this$order !== void 0 && _this$order.european_union_member);
    },
    isOrderForHoreca: function isOrderForHoreca() {
      return this.order.user.user_group === "HORECA" || this.order.user.user_group === "WHOLESALER" || this.order.user.isHolding;
    },
    isOrderForHorecaUs: function isOrderForHorecaUs() {
      return this.isOrderForHoreca && this.order.delivery_address.country.iso_2 === "US";
    },
    isOrderForIndividualUs: function isOrderForIndividualUs() {
      var _this$order2, _this$order3;
      return ((_this$order2 = this.order) === null || _this$order2 === void 0 || (_this$order2 = _this$order2.user) === null || _this$order2 === void 0 ? void 0 : _this$order2.user_group) === "USER" && ((_this$order3 = this.order) === null || _this$order3 === void 0 || (_this$order3 = _this$order3.delivery_address) === null || _this$order3 === void 0 ? void 0 : _this$order3.country.iso_code) === "USA";
    },
    isDocumentsConsultable: function isDocumentsConsultable() {
      return this.order.status !== this.orderStatus.find(function (x) {
        return x.id === "ADJUSTING";
      }).status && this.order.isFullyCalculatedAmounts;
    },
    hasBeenValidated: function hasBeenValidated() {
      return !orderStatus.filter(function (x) {
        return ["AWAITING_CUSTOMER_VALIDATION", "AWAITING_VALIDATION", "ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isShipped: function isShipped() {
      return orderStatus.filter(function (x) {
        return ["DELIVERY", "CUSTOMS_CLEARANCE", "INBOUND", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isCancelled: function isCancelled() {
      return this.order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    },
    isDelivered: function isDelivered() {
      return orderStatus.find(function (x) {
        return x.id === "DELIVERED";
      }).status === this.order.status;
    },
    isInvoiceConsultable: function isInvoiceConsultable() {
      var _this$order$importer;
      return this.order.isInvoiced && !((_this$order$importer = this.order.importer) !== null && _this$order$importer !== void 0 && _this$order$importer.isInternalImporter) && (this.isShipped || this.isCancelled);
    },
    isImporterInvoiceConsultable: function isImporterInvoiceConsultable() {
      return this.order.isImporterInvoiced && (this.isShipped || this.isCancelled);
    },
    isConcernedByVat: function isConcernedByVat() {
      var _this$order4;
      return ((_this$order4 = this.order) === null || _this$order4 === void 0 ? void 0 : _this$order4.amount_vat) > 0;
    },
    groupedItemsByDeparture: function groupedItemsByDeparture() {
      var _this4 = this;
      if (!this.isShippingEditable) {
        return this.order.items.reduce(function (acc, x) {
          if (acc[0].length) acc[0][0] = [].concat(_toConsumableArray(acc[0][0]), [x]);else acc[0] = [].concat(_toConsumableArray(acc[0]), [[x]]);
          return acc;
        }, [[]]);
      }
      if (!this.expedition_methods.length) return [];
      return this.order.items.reduce(function (acc, x) {
        var shippingMethods = _this4.expedition_methods.filter(function (e) {
          return e.itemIds.includes(x.id_item);
        });
        var current = _objectSpread(_objectSpread({}, x), {}, {
          shippingMethods: shippingMethods
        });
        var index = acc[0].findIndex(function (i) {
          return i.some(function (ii) {
            return ii.shippingMethods.some(function (s) {
              return s.itemIds.includes(x.id_item);
            });
          });
        });
        if (index >= 0) acc[0][index] = [].concat(_toConsumableArray(acc[0][index]), [current]);else acc[0] = [].concat(_toConsumableArray(acc[0]), [[current]]);
        return acc;
      }, [[]]);
    },
    groupedItemsRoot: function groupedItemsRoot() {
      return this.groupedItemsByDeparture[0];
    },
    hasMissingLogisticCost: function hasMissingLogisticCost() {
      return this.isShippingEditable && !this.isFetchingShippingCosts && (!this.groupedItemsRoot || !this.getAnyShippingMethod(this.groupedItemsRoot[0]));
    },
    isShippingEditable: function isShippingEditable() {
      return this.isOrderAwaitingCustomerValidation;
    },
    isOrderAwaitingCustomerValidation: function isOrderAwaitingCustomerValidation() {
      return this.order.status == this.orderStatus.find(function (os) {
        return os.id === "AWAITING_CUSTOMER_VALIDATION";
      }).status;
    },
    dialogAdjustmentData: function dialogAdjustmentData() {
      switch (this.dialogAdjustment.type) {
        case orderAdjustmentsTypes.USER_DECLINE.id:
          return {
            title: this.isOrderAwaitingCustomerValidation ? "Decline the order" : "Cancel the order",
            message_placeholder: "Please explain the reason for cancelling the order.",
            cta_label: "Decline order",
            success_toast_message: "Order has been declined and cancelled."
          };
        case orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id:
          return {
            title: "Ask for adjustments",
            message_placeholder: "Please explain your adjustments wishes",
            cta_label: "Send your request",
            success_toast_message: "Request has been sent."
          };
        case orderAdjustmentsTypes.USER_APPROVE.id:
          return {
            title: "Approve order",
            message_placeholder: "Please explain your approvement",
            cta_label: "Approve",
            success_toast_message: "Approvement has been sent."
          };
        case orderAdjustmentsTypes.ADMIN_DECLINE.id:
          return {
            title: "Cancel order",
            message_placeholder: "Please explain why you cancel this order to the customer. This message will be surrounded by standard message ; Before : Dear %CUSTOMER_NAME%, The order %ORDER_REFERENCE% has been cancelled. After : button 'View the order' Best regards.",
            cta_label: "Send to customer",
            success_toast_message: "Order cancelled."
          };
        case orderAdjustmentsTypes.ADMIN_PROPOSE_ADJUSTMENT.id:
          return {
            title: "Propose the adjustments",
            message_placeholder: "Please explain your adjustments to the customer. This message will be surrounded by standard message ; Before : Dear %CUSTOMER_NAME%, We are suggesting a couple of adjustments for your %ORDER_REFERENCE%. After : You can approve, or propose some adjustments. button 'View the order'. Best regards.",
            cta_label: "Send to customer",
            success_toast_message: "Proposition sent."
          };
        case "history":
          return {
            title: "History",
            message_placeholder: null,
            cta_label: null,
            success_toast_message: null
          };
        default:
          return null;
      }
    },
    nbBottles: function nbBottles() {
      var _this$order$items;
      return (_this$order$items = this.order.items) === null || _this$order$items === void 0 ? void 0 : _this$order$items.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0);
    },
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/order/").concat(this.order.id_order, "/files");
    },
    documentCount: function documentCount() {
      var _this$documents;
      return (_this$documents = this.documents) === null || _this$documents === void 0 ? void 0 : _this$documents.reduce(function (acc, x) {
        return acc + x.children.length;
      }, 0);
    },
    paymentState: function paymentState() {
      return _paymentState;
    },
    deliveryInstructionsEditable: function deliveryInstructionsEditable() {
      return !this.hasBeenValidated && !this.isCancelled;
    },
    isImporterPreventPayment: function isImporterPreventPayment() {
      var _this$order5, _this$order6;
      return +((_this$order5 = this.order) === null || _this$order5 === void 0 || (_this$order5 = _this$order5.importer) === null || _this$order5 === void 0 ? void 0 : _this$order5.id) > 0 && ((_this$order6 = this.order) === null || _this$order6 === void 0 || (_this$order6 = _this$order6.importer) === null || _this$order6 === void 0 ? void 0 : _this$order6.isPreventingPayment);
    },
    itemsRequiringTastingPhoto: function itemsRequiringTastingPhoto() {
      var _this$order$items$fil, _this$order7;
      return (_this$order$items$fil = (_this$order7 = this.order) === null || _this$order7 === void 0 ? void 0 : _this$order7.items.filter(function (x) {
        return x.wine.isTastingPhotoRequired;
      })) !== null && _this$order$items$fil !== void 0 ? _this$order$items$fil : [];
    },
    userData: function userData() {
      return String.parseForVHtml(getFullNameUserHtml(this.order.user));
    }
  },
  methods: {
    getAnyGroupedItem: function getAnyGroupedItem(groupedItems) {
      return groupedItems[0];
    },
    getAnyShippingMethod: function getAnyShippingMethod(groupedItems) {
      return this.getAnyGroupedItem(groupedItems).shippingMethods[0];
    },
    isShippingSetAvailable: function isShippingSetAvailable(groupedItems) {
      var _groupItem$shippingMe;
      var groupItem = this.getAnyGroupedItem(groupedItems);
      var expedtionMethod = groupItem.expeditionMethod;
      return !!expedtionMethod && ((_groupItem$shippingMe = groupItem.shippingMethods) === null || _groupItem$shippingMe === void 0 ? void 0 : _groupItem$shippingMe.filter(function (x) {
        return x.expedition_method == expedtionMethod;
      }).length) > 0;
    },
    toogleCollapseItemsList: function toogleCollapseItemsList(index) {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) {
        this.$nextTick(function () {
          document.querySelector("#order-summary-".concat(index)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        });
      }
    },
    fetchOrder: function fetchOrder(_, ack) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this5;
              _context2.next = 3;
              return request("/v1/order/" + _this5.order.id_order, "get", null, true, "api").catch(function (e) {
                if (e.response.data) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                }
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this5.order = _objectSpread(_objectSpread({}, _this5.order), response.data);
              ack(_this5.order);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cancelAddresses: function cancelAddresses() {
      this.isEditingAddresses = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        delivery_address: this.bufferedAddresses.deliveryAddress
      });
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
      this.sameAddress = this.bufferedAddresses.isSameAddress;
    },
    editAddresses: function editAddresses() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.order.delivery_address),
        billingAddress: _objectSpread({}, this.order.billing_address),
        isSameAddress: this.sameAddress
      };
    },
    cancelBillingAddress: function cancelBillingAddress() {
      this.isEditingAddresses = false;
      this.mustRecalculateCharges = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
    },
    editBillingAddress: function editBillingAddress() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        billingAddress: _objectSpread({}, this.order.billing_address)
      };
    },
    isActiveItem: function isActiveItem(item) {
      return !item.hasClosedStock && item.wine.is_active && !item.wine.deleted && !item.wine.isClosedStock;
    },
    openDocument: function openDocument(item) {
      window.open(item.url, "_blank");
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    calculateChargeForOrder: function calculateChargeForOrder() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.isFetchingShippingCosts = true;
              _this = _this6;
              _context4.next = 4;
              return request("/v1/order/".concat(_this6.order.id_order, "/logistic/"), "get", null, true, "api", null).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(db) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this.computeCharges(db.data);
                      case 2:
                        _this.isFetchingShippingCosts = false;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function () {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 4:
              if (!_this6.order.isFullyCalculatedAmounts) {
                _this6.order = calculateOrderAmountsLocal(_this6.order);
              }
              _this6.isCalculatingCharge = false;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    computeCharges: function computeCharges(db) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var groupedShippingMethodsByDeparture, _this, shippingAmount, totalAmountCurrency;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.expedition_methods = _this7.getAvailableExpeditionMethods(db);
              _this7.expedition_methods = [].concat(_toConsumableArray(_this7.expedition_methods.filter(function (m) {
                return m.expedition_method !== 6;
              })), _toConsumableArray(_this7.expedition_methods.filter(function (m) {
                return m.expedition_method === 6;
              })));
              _context5.next = 4;
              return _this7.initShippingMethod();
            case 4:
              groupedShippingMethodsByDeparture = _this7.expedition_methods.reduce(function (acc, x) {
                if (!acc[x.departureWarehouseId]) return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [x]));
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [].concat(_toConsumableArray(acc[x.departureWarehouseId]), [x])));
              }, {}); // Compute order shipping amount
              _this = _this7;
              Object.values(groupedShippingMethodsByDeparture).forEach(function (x) {
                var _x2 = _slicedToArray(x, 1),
                  anyShippingMethod = _x2[0];
                if (x.length === 1) {
                  _this.order.expedition_methods[anyShippingMethod.departureWarehouseId] = anyShippingMethod;
                }
                _this.order.items.filter(function (e) {
                  return anyShippingMethod.itemIds.includes(e.id_item);
                }).forEach(function (e) {
                  if (x.length === 1) e.expeditionMethod = anyShippingMethod.expedition_method;
                  if (!e.expeditionMethod) {
                    var itemWithExistingShippingMethod = _this.order.items.filter(function (it) {
                      return anyShippingMethod.itemIds.includes(it.id_item);
                    }).find(function (it) {
                      return !!it.expeditionMethod;
                    });
                    if (itemWithExistingShippingMethod) {
                      e.expeditionMethod = itemWithExistingShippingMethod.expeditionMethod;
                    }
                  }
                  if (!!e.expeditionMethod) {
                    var shippingMethod = x.find(function (s) {
                      return s.id === e.expeditionMethod;
                    });
                    if (shippingMethod) {
                      e.totalShipping = shippingMethod.price_numeric_currency;
                      e.shippingAmount = e.totalShipping / anyShippingMethod.itemIds.length;
                    }
                  }
                });
              });
              shippingAmount = _this7.order.items.reduce(function (acc, x) {
                return acc + x.shippingAmount || 0;
              }, 0);
              totalAmountCurrency = shippingAmount + _this7.order.items.reduce(function (acc, x) {
                return acc + x.unit_price_currency * x.quantity;
              }, 0);
              _this7.order = _objectSpread(_objectSpread({}, _this7.order), {}, {
                amount_shipping_currency: shippingAmount,
                total_amount_currency: totalAmountCurrency,
                total_amount_currency_include_credit_notes: totalAmountCurrency - _this7.order.credit_notes_amount_currency
              });
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    initShippingMethod: function initShippingMethod() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var initialShippingMethod, _this8$expedition_met, eta_min_hours, eta_max_hours, expedition_method, anyItem, shippingMethod;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              initialShippingMethod = _this8.order.expedition_method;
              if (!(_this8.expedition_methods.length === 1 && !_this8.expedition_methods[0].isErrorEvenSuperAdmin)) {
                _context6.next = 10;
                break;
              }
              _this8$expedition_met = _this8.expedition_methods[0], eta_min_hours = _this8$expedition_met.eta_min_hours, eta_max_hours = _this8$expedition_met.eta_max_hours, expedition_method = _this8$expedition_met.expedition_method;
              _this8.order.expedition_method = expedition_method;
              _this8.order.items.forEach(function (x) {
                return x.expeditionMethod = expedition_method;
              });
              _this8.order.eta_min_hours = eta_min_hours;
              _this8.order.eta_max_hours = eta_max_hours;
              if (!(_this8.order.expedition_method !== initialShippingMethod)) {
                _context6.next = 10;
                break;
              }
              _context6.next = 10;
              return _this8.updateExpeditionMethod();
            case 10:
              _this8.order.expedition_methods = _this8.expedition_methods.reduce(function (acc, x) {
                var item = _this8.order.items.find(function (e) {
                  return x.itemIds.includes(e.id_item);
                });
                if (item && item.expeditionMethod === x.expedition_method) {
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, x));
                }
                return acc;
              }, {});
              if (_this8.isShippingEditable) {
                anyItem = _this8.order.items[0];
                shippingMethod = _this8.expedition_methods.find(function (x) {
                  return anyItem.expeditionMethod === x.expedition_method;
                });
                if (!!shippingMethod) {
                  _this8.order.expedition_method = shippingMethod.expedition_method;
                  _this8.order.eta_min_hours = shippingMethod.eta_min_hours;
                  _this8.order.eta_max_hours = shippingMethod.eta_max_hours;
                } else {
                  _this8.order.expedition_method = null;
                }
              }
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getAvailableExpeditionMethods: function getAvailableExpeditionMethods(db) {
      var _this9 = this;
      return db.expedition_prices.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.expedition_price) >= 0) {
          var method_ref = Object.values(_this9.expedition_methods_ref).filter(function (ep) {
            return ep.id === x.expedition_method;
          })[0];
          var priceExp = x.expeditionPriceCurrency;
          return _objectSpread(_objectSpread({}, x), {}, {
            id: x.expedition_method,
            departureWarehouseId: x.departureWarehouseId,
            icon: method_ref.faIcon,
            label: method_ref.text,
            price_numeric_currency: priceExp,
            price_label: "+ ".concat(formatPrice(priceExp / x.itemIds.length), " ").concat(_this9.getSymbolCurrency(_this9.order.currency), " / bottle"),
            price_global_label: formatPrice(priceExp) + " " + _this9.getSymbolCurrency(_this9.order.currency),
            eta_label: _this9.getEtaLabel(x.eta_min_hours, x.eta_max_hours),
            original_object: x
          });
        }
      });
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    updateDeliveryInstructions: function updateDeliveryInstructions() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this10$updateDeliver;
        var path, data;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              (_this10$updateDeliver = _this10.updateDeliveryInstructionsToken) === null || _this10$updateDeliver === void 0 || _this10$updateDeliver.cancel();
              _this10.updateDeliveryInstructionsToken = axios.CancelToken.source();
              path = "/v1/orders/" + _this10.order.id_order + "/delivery-instructions";
              data = {
                DeliveryInstructions: _this10.order.delivery_instructions,
                isSetAsDefaultForUserAddress: _this10.isSetDeliveryAddressAsDefaultForUserAddress
              };
              _context7.next = 6;
              return request(path, "put", data, true, "api", null, _this10.updateDeliveryInstructionsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update delivery instructions.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              _this10.editingDeliveryInstructions = false;
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    isOrderDeliveryInstructionsDefaultUser: function isOrderDeliveryInstructionsDefaultUser() {
      return String.isNullOrEmpty(this.order.delivery_instructions) && String.isNullOrEmpty(this.order.delivery_address.deliveryInstructions) || this.order.delivery_instructions === this.order.delivery_address.deliveryInstructions;
    },
    continueToPayment: function continueToPayment() {
      var afterValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.sameAddress) {
        this.order.billing_address = this.order.delivery_address;
      }
      if (afterValidation) {
        setCurrentPayment(this.order);
        this.$router.push({
          name: "orderPayment"
        });
      } else {
        if (this.checkInputsPayment()) {
          this.isProcessingPayment = true;
          var _this11 = this;
          request("/v1/order", "put", this.order, true, "api").then(function (response) {
            _this11.isProcessingPayment = false;
            setCurrentPayment(response.data);
            _this11.$router.push({
              name: "orderPayment"
            });
          });
        }
      }
    },
    userValidateOrderWithoutPayment: function userValidateOrderWithoutPayment() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var response, _this13;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (_this12.sameAddress) {
                _this12.order.billing_address = _this12.order.delivery_address;
              }
              if (!_this12.checkInputsPayment()) {
                _context8.next = 13;
                break;
              }
              _this12.$EventBus.$emit("loading", true);
              _context8.next = 5;
              return request("/v1/order", "put", _this12.order, true, "api");
            case 5:
              response = _context8.sent;
              _this12.order = _objectSpread(_objectSpread({}, _this12.order), response.data);
              _this13 = _this12;
              _context8.next = 10;
              return request("/v1/order/" + _this12.order.id_order + "/state/" + _this12.orderStatus.find(function (x) {
                return x.id == "AWAITING_VALIDATION";
              }).status, "put", {}, true, "api").then(function () {
                _this13.$toasted.show("Order updated.", {
                  type: "success"
                });
              }).catch(function () {
                _this13.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                _this13.$EventBus.$emit("loading", false);
                throw e;
              });
            case 10:
              _context8.next = 12;
              return _this13.fetchOrder(null, function () {});
            case 12:
              _this12.$EventBus.$emit("loading", false);
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    changeExpeditionMethod: function changeExpeditionMethod(value, groupedItems) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _lastExpeditionMethod, _lastExpeditionMethod2, lastExpeditionMethods, _lastExpeditionMethod3, isDeselectingCellar, confirmed, _this15;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this14.errorLabels.quantity_orders = [];
              _this14.errorLabels.shipping = {};
              if (!(_this14.order.credit_notes_amount_currency > 0 && parseFloat((_this14.order.total_amount_currency - _this14.order.amount_shipping_currency - _this14.order.credit_notes_amount_currency + parseFloat(value.price_numeric_currency)).toFixed(2)) < 0)) {
                _context9.next = 7;
                break;
              }
              _this14.$toasted.show("Due to applied credits, you couldn't use this shipment method.", {
                type: "warning"
              });
              _this14.$nextTick(function () {
                _this14.order = _objectSpread(_objectSpread({}, _this14.order), {}, {
                  expedition_methods: _defineProperty({}, _this14.order.id_warehouse, _this14.lastExpeditionMethod)
                });
              });
              _context9.next = 36;
              break;
            case 7:
              if (!_this14.order.expedition_methods) _this14.order.expedition_methods = {};
              lastExpeditionMethods = _objectSpread({}, _this14.order.expedition_methods);
              if (!((value.expedition_method === expeditionMethods.CELLAR_STORAGE.id || ((_lastExpeditionMethod = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod === void 0 ? void 0 : _lastExpeditionMethod.id) === expeditionMethods.CELLAR_STORAGE.id) && value.expedition_method !== ((_lastExpeditionMethod2 = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod2 === void 0 ? void 0 : _lastExpeditionMethod2.id))) {
                _context9.next = 30;
                break;
              }
              isDeselectingCellar = ((_lastExpeditionMethod3 = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod3 === void 0 ? void 0 : _lastExpeditionMethod3.id) === expeditionMethods.CELLAR_STORAGE.id;
              _context9.next = 13;
              return _this14.$refs.confirm.open("To your attention", isDeselectingCellar ? "When deselecting this type of shipment, be aware that duties and taxes will be included in the products. Wine's prices will be update." : "When choosing the type of shipment « stored at the cellar », please be aware that duties and taxes will no longer be included on the products and may be charged to you later by the financial authorities. Product prices will be updated.", {
                color: "warning"
              });
            case 13:
              confirmed = _context9.sent;
              if (!confirmed) {
                _context9.next = 26;
                break;
              }
              _this14.$EventBus.$emit("loading", true);
              _this14.order.expedition_method = value.expedition_method;
              _this14.order.eta_min_hours = value.eta_min_hours;
              _this14.order.eta_max_hours = value.eta_max_hours;
              _this14.order.expedition_methods[value.departureWarehouseId] = value;
              _this14.computeShippingAmount(groupedItems, value.id, value.price_numeric_currency);
              if (_this14.order.expedition_method === expeditionMethods.CELLAR_STORAGE.id) {
                _this14.order.is_destination_inbound = false;
                _this14.order.stockTransferIsAskedByUser = false;
              }
              _this15 = _this14;
              request("/v1/order", "put", _this15.order, true, "api").then(function (response) {
                _this15.$EventBus.$emit("loading", false);
                _this15.$nextTick(function () {
                  _this15.order = _objectSpread(_objectSpread({}, _this15.order), {}, {
                    expedition_methods: _objectSpread(_objectSpread({}, _this15.order.expedition_methods), {}, _defineProperty({}, value.departureWarehouseId, value))
                  }, response.data);
                  _this15.computeShippingAmount(groupedItems, value.id, value.price_numeric_currency);
                });
              });
              _context9.next = 28;
              break;
            case 26:
              _this14.order = _objectSpread(_objectSpread({}, _this14.order), {}, {
                expedition_methods: _objectSpread({}, lastExpeditionMethods)
              });
              return _context9.abrupt("return");
            case 28:
              _context9.next = 35;
              break;
            case 30:
              _this14.order.expedition_method = value.expedition_method;
              _this14.order.eta_min_hours = value.eta_min_hours;
              _this14.order.eta_max_hours = value.eta_max_hours;
              _this14.order.expedition_methods[value.departureWarehouseId] = value;
              _this14.computeShippingAmount(groupedItems, value.id, value.price_numeric_currency);
            case 35:
              _this14.$nextTick(function () {
                _this14.order.expedition_method = value.expedition_method;
                _this14.order.expedition_methods = _objectSpread(_objectSpread({}, _this14.order.expedition_methods), {}, _defineProperty({}, value.departureWarehouseId, value));
              });
            case 36:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    computeShippingAmount: function computeShippingAmount(groupedItems, shippingMethod, totalShipping) {
      var _this16 = this;
      var _iterator = _createForOfIteratorHelper(groupedItems),
        _step;
      try {
        var _loop = function _loop() {
          var groupedItem = _step.value;
          var item = _this16.order.items.find(function (i) {
            return i.id_item === groupedItem.id_item;
          });
          var index = _this16.order.items.indexOf(item);
          _this16.order.items.splice(index, 1, _objectSpread(_objectSpread({}, item), {}, {
            expeditionMethod: shippingMethod,
            totalShipping: totalShipping
          }));
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var shippingAmount = this.groupedItemsByDeparture[0].reduce(function (acc, x, i) {
        var _x$;
        if (i === _this16.groupedItemsByDeparture[0].indexOf(groupedItems)) return acc;
        return acc + (((_x$ = x[0]) === null || _x$ === void 0 ? void 0 : _x$.totalShipping) || 0);
      }, 0);
      var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
        return acc + x.unit_price_currency * x.quantity;
      }, 0);
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        amount_shipping_currency: shippingAmount,
        total_amount_currency: totalAmountCurrency,
        total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
      });
    },
    refetchDocs: function refetchDocs() {
      if (this.isDocumentsConsultable) {
        var _this17 = this;
        _this17.loadingDocuments = true;
        request("/v1/orders/" + _this17.order.id_order + "/docs", "get", null, true, "api").then(function (_ref2) {
          var data = _ref2.data;
          _this17.loadingDocuments = false;
          _this17.documents = data.filter(function (x) {
            var _x$document_urls;
            return ((_x$document_urls = x.document_urls) === null || _x$document_urls === void 0 ? void 0 : _x$document_urls.length) > 0;
          }).reduce(function (acc, x) {
            return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
              children: _toConsumableArray(x.document_urls)
            })]);
          }, []);
        });
      }
    },
    fetchAdjustments: function fetchAdjustments() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return request("/v1/orders/" + _this18.order.id_order + "/adjustments", "get", null, true, "api").catch(function (_) {
                _this18.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 2:
              response = _context10.sent;
              _this18.adjustments = response.data;
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    saveAddress: function saveAddress() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this19$updateAddress;
        var _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              (_this19$updateAddress = _this19.updateAddressesToken) === null || _this19$updateAddress === void 0 || _this19$updateAddress.cancel();
              _this19.updateAddressesToken = axios.CancelToken.source();
              _this = _this19;
              _context11.next = 5;
              return request("/v1/order/".concat(_this19.order.id_order, "/addresses"), "put", {
                deliveryAddress: _this.order.delivery_address,
                billingAddress: _this.order.billing_address
              }, true, "api", null, _this19.updateAddressesToken).then(function (_) {
                _this.isEditingAddresses = false;
                _this.refetchDocs();
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update addresses.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    addressChange: function addressChange() {
      if (this.sameAddress) {
        this.order.billing_address = _objectSpread({}, this.order.delivery_address);
      }
    },
    userValidateOrder: function userValidateOrder() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!(!_this20.checkboxCGV || !_this20.checkboxLawCompliance)) {
                _context12.next = 3;
                break;
              }
              _this20.errorLabels.cgv = _this20.errorMessages.cgv.required;
              return _context12.abrupt("return");
            case 3:
              _context12.next = 5;
              return request("/v1/order", "put", _this20.order, true, "api");
            case 5:
              response = _context12.sent;
              _this20.order = _objectSpread({}, response.data);
              _this20.dialogAdjustment.type = orderAdjustmentsTypes.USER_APPROVE.id;
              _context12.next = 10;
              return _this20.dialogAdjustmentAction();
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    dialogAdjustmentAction: function dialogAdjustmentAction() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, _this$adjustmentToken, path, data;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this21.errorLabels.adjustment = "";
              if (!(_this21.dialogAdjustment.type == orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id)) {
                _context13.next = 5;
                break;
              }
              if (!(!_this21.dialogAdjustment.message || _this21.dialogAdjustment.message.length < 1)) {
                _context13.next = 5;
                break;
              }
              _this21.errorLabels.adjustment = _this21.errorMessages.mandatory;
              return _context13.abrupt("return");
            case 5:
              _this21.isCreatingAdjustment = true;
              _this = _this21;
              _context13.prev = 7;
              (_this$adjustmentToken = _this.adjustmentToken) === null || _this$adjustmentToken === void 0 || _this$adjustmentToken.cancel();
              _this.adjustmentToken = axios.CancelToken.source();
              path = "/v1/orders/adjustments";
              data = {
                order_id: _this.order.id_order,
                type: _this.dialogAdjustment.type,
                custom_message: _this.dialogAdjustment.message
              };
              _context13.next = 14;
              return request(path, "post", data, true, "api", null, _this.adjustmentToken);
            case 14:
              _context13.next = 16;
              return _this.fetchOrder(null, function () {});
            case 16:
              if (_this21.dialogAdjustment.type != orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id) {
                _this.refetchDocs();
              }
              _context13.next = 19;
              return _this.fetchAdjustments();
            case 19:
              _this.dialogAdjustment.message = "";
              _this.dialogAdjustment.visible = false;
              _this.$toasted.show(_this.dialogAdjustmentData.success_toast_message, {
                type: "success"
              });
              _context13.next = 27;
              break;
            case 24:
              _context13.prev = 24;
              _context13.t0 = _context13["catch"](7);
              if (!axios.isCancel(_context13.t0)) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              }
            case 27:
              _this21.isCreatingAdjustment = false;
            case 28:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[7, 24]]);
      }))();
    },
    checkInputs: function checkInputs() {
      var _this22 = this,
        _this$itemsRequiringT;
      var valid = true;
      this.errorLabels.shipping = {};
      var _this$groupedItemsRoo = this.groupedItemsRoot.filter(function (x) {
          return x.some(function (i) {
            return !i.expeditionMethod || _this22.expedition_methods.filter(function (e) {
              return e.itemIds.includes(i.id_item);
            }).every(function (e) {
              return i.expeditionMethod !== e.expedition_method;
            });
          });
        }),
        _this$groupedItemsRoo2 = _slicedToArray(_this$groupedItemsRoo, 1),
        shippingMethods = _this$groupedItemsRoo2[0];
      if (!!(shippingMethods !== null && shippingMethods !== void 0 && shippingMethods.length)) {
        this.errorLabels.shipping = shippingMethods.reduce(function (acc, x) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.shippingMethods[0].departureWarehouseId, _this22.errorMessages.shippingType.required));
        }, {});
        valid = false;
      }
      this.errorLabels.terms = "";
      this.errorLabels.cgv = "";
      this.errorLabels.tastingPhoto = "";
      if (!this.checkboxCGV || !this.checkboxLawCompliance) {
        this.errorLabels.cgv = this.errorMessages.cgv.required;
        valid = false;
      }
      if (this.order.buyer_term == null) {
        this.errorLabels.terms = this.errorMessages.mandatory;
        valid = false;
      }
      if (((_this$itemsRequiringT = this.itemsRequiringTastingPhoto) === null || _this$itemsRequiringT === void 0 ? void 0 : _this$itemsRequiringT.length) > 0) {
        var itemIdsRequiringTastingPhoto = this.itemsRequiringTastingPhoto.map(function (x) {
          return x.id_item;
        });
        if (itemIdsRequiringTastingPhoto.some(function (id) {
          return !_this22.checkboxTastingPhoto[id];
        })) {
          this.errorLabels.tastingPhoto = this.errorMessages.tastingPhoto.required;
          valid = false;
        }
      }
      if (!this.isStoredInbound && !this.$refs.deliveryAddress.validateForm()) {
        valid = false;
      }
      if (!this.sameAddress && !this.$refs.billingAddress.validateForm()) {
        valid = false;
      }
      return valid;
    },
    checkInputsPayment: function checkInputsPayment() {
      var _this23 = this;
      var valid = this.checkInputs();
      this.errorLabels.quantity_orders = [];
      var amountCurrencyByPassVolume = this.$whitelabel.orderLimitMinPriceWithoutShipping * this.order.currencyRate;
      var invalidOrders = this.groupedItemsRoot.filter(function (g) {
        return g.reduce(function (acc, i) {
          return acc + i.quantity * i.wine.bottling;
        }, 0) < _this23.$whitelabel.orderLimitMinVolume && g.reduce(function (acc, i) {
          return acc + i.total_amount_currency - ((i === null || i === void 0 ? void 0 : i.totalShipping) || 0);
        }, 0) < amountCurrencyByPassVolume;
      });
      if (!!invalidOrders.length) {
        valid = false;
        this.errorLabels.quantity_orders = invalidOrders.map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
            x = _ref4[0];
          var _x$shippingMethods = _slicedToArray(x.shippingMethods, 1),
            shippingMethod = _x$shippingMethods[0];
          return {
            anchor: shippingMethod.id,
            text: "Minimum order quantity of " + parseInt(_this23.$whitelabel.orderLimitMinVolume / REGULAR_BOTTLING) + " bottles (" + _this23.$whitelabel.orderLimitMinVolume / 1000 + "L) or " + _this23.formatPrice(amountCurrencyByPassVolume) + " " + _this23.getSymbolCurrency(_this23.order.currency) + " of total value"
          };
        });
      }
      return valid;
    },
    openToS: function openToS() {
      var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var routeData = this.$router.resolve({
        name: "userTermsOfSales",
        hash: anchor
      });
      window.open(routeData.href);
    },
    redirectToWineCatalog: function redirectToWineCatalog() {
      this.$router.push({
        name: "adminProductList"
      });
    },
    startEditDeliveryInstructions: function startEditDeliveryInstructions() {
      var _this24 = this;
      this.editingDeliveryInstructions = true;
      this.$nextTick(function (_) {
        _this24.$refs.inputDeliveryInstruction.focus();
      });
    },
    getRequiredTastingPhotos: function getRequiredTastingPhotos() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this25$order;
        var _this25$order2, _this26, formSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!(_this25.tastingPhotos.canManage && _this25.isDelivered && (_this25$order = _this25.order) !== null && _this25$order !== void 0 && _this25$order.hasTastingPhotoRequired)) {
                _context14.next = 11;
                break;
              }
              _this25.tastingPhotos.required.isSearchPending = true;
              _this25.tastingPhotos.required.items = [];
              _this26 = _this25;
              formSearch = {
                orderIds: [(_this25$order2 = _this25.order) === null || _this25$order2 === void 0 ? void 0 : _this25$order2.id_order],
                allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
              };
              paramsQuery = Object.encodeToUri(formSearch);
              _context14.next = 8;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api").catch(function (e) {
                _this26.tastingPhotos.required.isSearchPending = false;
                _this26.$toasted.show("Unable to load required photos.", {
                  type: "error"
                });
                throw e;
              });
            case 8:
              response = _context14.sent;
              _this25.tastingPhotos.required.items = _toConsumableArray(response.data.value);
              _this25.tastingPhotos.required.isSearchPending = false;
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    openTastingPhotoUploader: function openTastingPhotoUploader(tastingPhotoRequiredId) {
      var _this27 = this;
      this.tastingPhotos.upload.tastingPhotoRequiredId = tastingPhotoRequiredId;
      this.tastingPhotos.upload.isComponentCreated = true;
      this.$nextTick(function () {
        _this27.$refs.tastingPhotoUploadForm.open();
      });
    },
    closeTastingPhotoUploader: function closeTastingPhotoUploader() {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this28.tastingPhotos.upload.isComponentCreated = false;
              _this28.getRequiredTastingPhotos();
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUserHtml: getFullNameUserHtml,
    getFullNameUser: getFullNameUser,
    scrollTo: scrollTo,
    getOrderConfirmationReference: getOrderConfirmationReference,
    isAllowedOrderWithoutPayment: isAllowedOrderWithoutPayment,
    getUnitPriceCurrencyForItem: getUnitPriceCurrencyForItem,
    showShippingPriceMinusDefault: showShippingPriceMinusDefault
  },
  watch: {
    "order.expedition_methods": function orderExpedition_methods(newVal, oldVal) {
      var _this29 = this;
      this.lastExpeditionMethod = _objectSpread({}, this.expedition_methods.find(function (x) {
        return x.id === _this29.order.expedition_method;
      }));
    }
  }
};